// CSV 导出工具: 前端拼 CSV → Blob 下载.
// 用 UTF-8 BOM 让 Excel 直接双击打开不乱码; 逗号/引号/换行按 RFC 4180 转义.

function escapeCell(v: unknown): string {
    if (v === null || v === undefined) return '';
    const s = String(v);
    if (/[",\n\r]/.test(s)) {
        return '"' + s.replace(/"/g, '""') + '"';
    }
    return s;
}

/**
 * 生成并下载 CSV.
 * @param filename 文件名 (含 .csv)
 * @param headers  表头行
 * @param rows     数据行 (与 headers 等长的单元格数组)
 */
export function downloadCsv(filename: string, headers: string[], rows: unknown[][]): void {
    const lines = [headers, ...rows].map((r) => r.map(escapeCell).join(','));
    const blob = new Blob(['﻿' + lines.join('\r\n')], {
        type: 'text/csv;charset=utf-8',
    });
    downloadBlob(filename, blob);
}

/** 触发浏览器下载一个内存里的 Blob. */
export function downloadBlob(filename: string, blob: Blob): void {
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(url);
}

/** 下载后端以 base64 回传的文件 (如导入回执 xlsx). */
export function downloadBase64(filename: string, base64: string, mime: string): void {
    const bin = atob(base64);
    const bytes = new Uint8Array(bin.length);
    for (let i = 0; i < bin.length; i += 1) bytes[i] = bin.charCodeAt(i);
    downloadBlob(filename, new Blob([bytes], { type: mime }));
}

/** 文件名里的日期后缀, 例 20260730-1512. */
export function dateSuffix(): string {
    const d = new Date();
    const p = (n: number) => String(n).padStart(2, '0');
    return `${d.getFullYear()}${p(d.getMonth() + 1)}${p(d.getDate())}-${p(d.getHours())}${p(d.getMinutes())}`;
}
